'use client';

import Link from 'next/link';
import type { ReactNode } from 'react';

import {
  trackFreeToolCtaClick,
  type FreeToolCtaSurface,
} from '@/components/free-tools/track-free-tool-cta';

/**
 * A `<Link>` that reports the click before navigating.
 *
 * Kept as its own tiny client component so `FreeToolCard` and `FreeToolCtaBand`
 * stay server components: only the link handler ships to the browser, not the
 * card markup. Tracking is fire-and-forget via sendBeacon, so navigation is
 * never delayed or blocked by it.
 */
export function TrackedToolLink({
  href,
  surface,
  slug,
  label,
  className,
  children,
}: {
  href: string;
  surface: FreeToolCtaSurface;
  /** Registry slug of the page the click happened ON. */
  slug?: string;
  /** Overrides the label reported; defaults to the destination. */
  label?: string;
  className?: string;
  children: ReactNode;
}) {
  return (
    <Link
      href={href}
      className={className}
      onClick={() => trackFreeToolCtaClick({ surface, slug, destination: href, label })}
    >
      {children}
    </Link>
  );
}
